export default {
  ADD_NEWS (state, news) {
    state.news = news
  },
  ADD_NEW_NEWS (state, news) {
    state.news.push(news)
  },
  DELETE_NEWS (state, id) {
    state.news = state.news.filter(s => s.id !== id)
  },
  CHANGE_NEWS_PHOTO (state, news) {
    const n = state.news.find(i => i.id === news.id)
    n.photos = news.photos
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/news.js